import { motion } from "framer-motion";
import StoreButtons from "@/components/StoreButtons";

const EASE = [0.16, 1, 0.3, 1];

export default function Download() {
  return (
    <section
      id="download"
      className="relative bg-brand-green text-black overflow-hidden scroll-mt-20"
      data-testid="download-section"
    >
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-black/10 rounded-full blur-[100px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32 relative">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: EASE }}
          >
            <p className="text-xs font-bold tracking-[0.3em] uppercase text-black/60 mb-5">
              The app
            </p>
            <h2 className="font-display font-semibold tracking-tight leading-[0.98] text-5xl sm:text-6xl lg:text-7xl max-w-2xl">
              Your ride is waiting.
            </h2>
            <p className="mt-6 text-black/70 max-w-md text-base md:text-lg font-medium leading-relaxed">
              One app for riders and drivers. Download EzRueda and be first in line when we
              flip the switch in Albany.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.15 }}
            className="shrink-0"
            data-testid="download-store-buttons"
          >
            <StoreButtons surface="green" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
